import { cn } from "@/lib/utils";
import { useGeneralSettings } from "@/Providers/General";
import { useToast } from "@/shadcnComponents/ui/use-toast";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
const host: string = import.meta.env.VITE_BACKEND_SERVER_URL;

export const AdminInfluencerCollabs = () => {
  const { toast } = useToast();
  const { id } = useParams();
  const [AllCollabs, setALLCollabs] = useState([]);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [influencer, setInfluencer] = useState<any>(null);
  const generalState = useGeneralSettings();

  useEffect(() => {
    const allcreators = async () => {
      generalState?.setLoading(true);
      const response = await fetch(
        `${host}/developer/influencer/getAllCollabs/?influencerId=${id}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Access-Control-Allow-Credentials": "true",
            jwtToken: localStorage.getItem("jwtTokenD"),
          },
        }
      );
      const json = await response.json();
      if (json.success) {
        generalState?.setLoading(false);
        setALLCollabs(json.AllPastCollaboration.data);
        setInfluencer(json.influencer);
      } else {
        generalState?.setLoading(false);
        //   toast.error("You are not allowed to Access", { autoClose: 1500 });
        //   handleLogout();
        window.open("/developer/login", "_self");
      }
    };
    allcreators();
  }, []);

  const handleRejectCollab = async (collabId: string) => {
    generalState?.setLoading(true);
    const response = await fetch(`${host}/developer/influencer/collab/reject`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json", // Specify JSON content type
        "Access-Control-Allow-Credentials": "true",
        jwtToken: localStorage.getItem("jwtTokenD"),
      },
      body: JSON.stringify({ collabId, influencerId: id }), // Properly stringified JSON
    });
    const json = await response.json();
    if (json.success) {
      const response = await fetch(
        `${host}/developer/influencer/getAllCollabs/?influencerId=${id}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Access-Control-Allow-Credentials": "true",
            jwtToken: localStorage.getItem("jwtTokenD"),
          },
        }
      );
      const json = await response.json();
      if (json.success) {
        generalState?.setLoading(false);
        setALLCollabs(json.AllPastCollaboration.data);
        setInfluencer(json.influencer);
      } else {
        generalState?.setLoading(false);
        //   toast.error("You are not allowed to Access", { autoClose: 1500 });
        //   handleLogout();
        window.open("/developer/login", "_self");
      }
      generalState?.setLoading(false);

      toast({
        title: "Collaboration Rejected",
      });
    } else {
      generalState?.setLoading(false);
      toast({
        title: json.message,
        variant: "destructive",
      });
      //   toast.error("You are not allowed to Access", { autoClose: 1500 });
      //   handleLogout();
      //   window.open("/developer/login", "_self");
    }
  };

  const handleApproveCollab = async (collabId: string) => {
    generalState?.setLoading(true);
    const response = await fetch(
      `${host}/developer/influencer/collab/approve`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json", // Specify JSON content type
          "Access-Control-Allow-Credentials": "true",
          jwtToken: localStorage.getItem("jwtTokenD"),
        },
        body: JSON.stringify({ collabId, influencerId: id }), // Properly stringified JSON
      }
    );
    const json = await response.json();
    if (json.success) {
      const response = await fetch(
        `${host}/developer/influencer/getAllCollabs/?influencerId=${id}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Access-Control-Allow-Credentials": "true",
            jwtToken: localStorage.getItem("jwtTokenD"),
          },
        }
      );
      const json = await response.json();
      if (json.success) {
        generalState?.setLoading(false);
        setALLCollabs(json.AllPastCollaboration.data);
        setInfluencer(json.influencer);
      } else {
        generalState?.setLoading(false);
        //   toast.error("You are not allowed to Access", { autoClose: 1500 });
        //   handleLogout();
        window.open("/developer/login", "_self");
      }
      generalState?.setLoading(false);

      toast({
        title: "Collaboration Approved",
      });
    } else {
      generalState?.setLoading(false);
      toast({
        title: json.message,
        variant: "destructive",
      });
      //   toast.error("You are not allowed to Access", { autoClose: 1500 });
      //   handleLogout();
      //   window.open("/developer/login", "_self");
    }
  };

  return (
    <div className="w-full flex flex-col items-center gap-[20px] font-inter ">
      <span className="font-bold ">
        Total Collab of Influencer - {influencer?.name}
      </span>
      <div className="w-full flex flex-wrap justify-center gap-6">
        {AllCollabs?.map((collab) => (
          <div
            key={collab._id}
            className="relative flex flex-col justify-between w-80 bg-white shadow-md rounded-lg overflow-hidden transition-transform transform hover:scale-105 hover:shadow-lg"
          >
            <div className="p-4">
              <h2 className="text-lg font-semibold text-gray-800">
                {collab.companyName}
              </h2>
              <p className="text-sm text-gray-500">
                <a
                  href={collab.companyUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-600 hover:underline"
                >
                  {collab.companyUrl}
                </a>
              </p>
              <p className="mt-2 text-gray-700">
                Post Link:{" "}
                <a
                  href={collab.postLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-600 hover:underline"
                >
                  View Post
                </a>
              </p>
              {/* <p className="mt-2 text-gray-700">
                <strong>Goals:</strong> {collab.goals.join(", ")}
              </p> */}
              <p className="mt-2 text-gray-700">
                <strong>RejectedByAdmin:</strong>{" "}
                {collab.RejectedByAdmin ? "true" : "false"}
              </p>
            </div>
            <div className="p-4 border-t bg-gray-50">
              <button
                onClick={() =>
                  collab.RejectedByAdmin
                    ? handleApproveCollab(collab._id)
                    : handleRejectCollab(collab._id)
                }
                className={cn(
                  "w-full  text-white py-2 px-4 rounded-md  transition",
                  collab.RejectedByAdmin
                    ? "bg-green-600 hover:bg-green-700"
                    : "bg-red-600 hover:bg-red-700"
                )}
              >
                {collab.RejectedByAdmin ? "Approve" : "Reject"}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
